export const serverError = '서버 처리중 작업 장애가 발생했습니다<br>잠시 후 다시 시도해주시기 바랍니다.'
export const serverUploadError = '파일 업로드중 오류가 발생하였습니다. <br> 파일 확장자<br> (jpg, png, bmp, tiff, webp, docx, xlsx, pptx 외 <br> 업로드 불가) <br> 및 크기를 확인해주세요.'
